<template>
  <el-container>

    <!-- Dialog Header -->
    <el-header height="max-content">
      <el-input 
        v-model="text"
        type="text"
        placeholder="ค้นหาชื่อ หรือ อีเมลเจ้าหน้าที่"
        @keypress.enter.native="
          change(text, 1)
        ">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="
            change(text, 1)
          ">
        </el-button>
      </el-input>
      <p class="text-secondary">
        พบข้อมูล {{ total }} คน
      </p>
    </el-header>
    
    <!-- Dialog Body -->
    <el-main
:style="{
      'max-height': '60vh'
    }">
      
      <!-- Admin Empty -->
      <el-empty
v-if="items.length < 1"
        :image-size="200"
        :description="description"
      />

      <!-- Admin List -->
      <div class="list-item">
        <div
          v-for="(item, i) of items" :key="i"
          class="
            grid-layout item el-card
          "
          @click="
            select(item)
          ">
          <el-avatar
            :size="80"
            shape="square">
            <b>{{ item.role }}</b>
          </el-avatar>
          <div class="content">
            <b>
              {{ item.first_name }} {{  item.last_name }}
            </b>
            <p class="text-secondary text-ellipsis">
              {{ item.email }}
            </p>
          </div>
        </div>
      </div>
    </el-main>
    
    <!-- Dialog Footer -->
    <el-footer height="max-content">
      <el-pagination
        v-if="
          items.length > 0
        "
        :current-page.sync="current"
        :page-size="size"
        :total="total"
        class="text-center"
        layout="
          prev, pager, next
        "
        @current-change="
          (page) => change(text, page)
        "
      />
    </el-footer>
    
  </el-container>
</template>

<script>

// LINE Notify Service
import { useCases } from '../LineNotifyService'

export default {
  name: 'LineNotifySelectAdmin',
  props: {
    search: {
      type: String,
      default: ''
    },
    page: {
      type: Number,
      default: 1
    },
    selected: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      current: 1,
      items: [],
      size: 10,
      text: '',
      total: 0,
      description: ''
    }
  },
  async created () {

    // Init Values
    this.text = this.search
    this.current = this.page

    // Fetch Data
    this.change(
      this.search, this.page
    )
  },
  methods: {
    async change (text, page) {

      // Change Page Event
      this.$emit(
        'page-change', { text, page }
      )

      // Current Page
      this.current = page

      // Fetch Admin Data
      await this.fetch()
    },
    select (item) {
      this.$emit('select', item)
    },
    async fetch () {

      // Fetch Admin List
      const result = await useCases.adminList(
        this.text, this.current, this.size
      )

      // Fetch Result
      const { code, message, items, total } = result

      // Filter Code
      switch (code) {
        case 20000:
          
          // Set Data 
          this.items = items
          this.total = total
          
          break;
        default:
          
          // Reset Data 
          this.items = []
          this.total = 0

          // Error Description
          this.description = message || 'ไม่พบข้อมูล'
          
          break
      }
    }
  }
}

</script>

<style scoped>

@import url('../LineNotify.css');

.el-avatar {
  background-color: var(--sc-color);
}

.item:hover .el-avatar {
  background-color: var(--sc-color-dark);
}

</style>
